(() => {
  const normalize = (value) => (value || '').trim().toUpperCase().replace(/\s+/g, '');
  const looksLikeCode = (value) => /^[A-Z0-9._\/-]{5,}$/.test(normalize(value));
  const lookup = async (term) => {
    const q = normalize(term); if (!looksLikeCode(q)) return null;
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show`);
      if (!response.ok) return null;
      const products = (await response.json())?.resources?.results?.products || [];
      for (const product of products) {
        try {
          const detail = await fetch(`${product.url}.js`).then((r) => r.ok ? r.json() : null);
          const variant = detail?.variants?.find((v) => normalize(v.sku) === q || normalize(v.barcode) === q);
          if (variant) return { url:`${product.url}?variant=${variant.id}`, title:product.title, sku:variant.sku, variantTitle:variant.public_title || variant.title };
        } catch (_) {}
      }
    } catch (_) {}
    return null;
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[role="search"]'); if (!form || form.dataset.bvjResolving === '1') return;
    const input = form.querySelector('input[type="search"]'); const term = input?.value || ''; if (!looksLikeCode(term)) return;
    event.preventDefault(); form.dataset.bvjResolving='1'; const match=await lookup(term);
    if (match) window.location.assign(match.url); else { form.dataset.bvjResolving='0'; HTMLFormElement.prototype.submit.call(form); }
  }, true);
  document.addEventListener('input', (event) => {
    const input=event.target.closest('predictive-search input[type="search"]'); if(!input || !looksLikeCode(input.value)) return;
    const host=input.closest('predictive-search'); clearTimeout(host._bvjVariantTimer);
    host._bvjVariantTimer=setTimeout(async()=>{ const term=input.value; const match=await lookup(term); if(!match||input.value!==term)return;
      let box=host.querySelector('.bvj-variant-search-hit'); if(!box){box=document.createElement('div');box.className='bvj-variant-search-hit';host.querySelector('[data-predictive-search]')?.prepend(box);}
      box.innerHTML=`<a class="predictive-search__item link link--text" href="${match.url}"><div class="predictive-search__item-content"><span class="caption-with-letter-spacing">Exact artikelnummer</span><p class="predictive-search__item-heading h5">${match.title}</p><span>${match.sku}${match.variantTitle?' · '+match.variantTitle:''}</span></div></a>`;
    },180);
  },true);
})();
